import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BrandFilterEntity } from '../../domain/entities/BrandsFilterEntity'

export class BrandsFilterModel extends BrandFilterEntity {
  constructor(dataDto:  BrandFilterEntity) {
    super()
    mapEntityProperties<BrandsFilterModel>(this, dataDto)
  }
}


 